import { SerializedData, Store } from "bernie-core";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { getBexApiContext } from "bernie-context";
import { ExtendedContextStore } from "../typings/flexFramework/FlexDefinitions";
import { MerchCouponsQuery } from "../../__generated__/api";
import { BexApiService } from "../services/BexApiService";
import { FAILED_COUPON_FETCH } from "../config/systemEvents";

export class CouponsStore extends Store {
  public bexApiService: BexApiService;

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER, bexApiService: BexApiService) {
    super(state, logger);
    this.bexApiService = bexApiService;
  }

  public hydrate(data: SerializedData): void {
    // The serialized store as returned by the server exposes a stripped down
    // version of bexApiService with no methods.We delete it here to prevent the override.
    delete data.bexApiService;
    Object.assign(this, data);
  }

  public async fetchMerchCoupons(contextStore: ExtendedContextStore, couponIds: string[]): Promise<any> {
    const variables: MerchCouponsQuery.Variables = {
      context: getBexApiContext(contextStore),
      couponIds,
    };
    try {
      const query = await this.bexApiService.fetchMerchCouponsQuery(variables);

      return query.data.merchCoupons?.coupons;
    } catch (err) {
      this.logger.logEvent(FAILED_COUPON_FETCH, "Unexpected error when fetching merch coupons", err);
    }
  }
}
